module.exports = __webpack_public_path__ + "img/poziom2.a62e7aa9.svg";